<main class="w-full">
	<label
		class="component-field-input-text show"
		[class.if-referenced]="isReferenced"
		[class.if-labeled]="isLabeled"
		[class.if-tabeled]="isTabeled"
		[class.if-disabled]="isDisabled"
		[class.if-touched]="isTouched && !isLoadingState"
		[class.if-error]="hasError || inputError"
		[class.if-valid]="isValidIcon"
		[class.if-loading]="isLoadingState"
		[class.pl-[24px]]="
			isLabeled && !isReferenced && !isTabeled && !inputComponetHelperIconLeftStyle
		"
		(mousedown)="preventDefault($event)"
		(click)="click()"
	>
		@if (inputComponetHelperIconLeftStyle) {
			<section class="if-section-left-icon">
				<lbca-icon [name]="inputComponetHelperIconLeftStyle"></lbca-icon>
			</section>
		}
		@if (isLabeled && !isReferenced && copy && !isTabeled) {
			<section
				title="Copiar!"
				(click)="copyToClipboard($event)"
				class="if-section-icon ico-copy-labeled cursor-pointer"
			>
				<lbca-icon name="lucide:copy" size="small" color="gray" />
			</section>
		}
		@if (!isLabeled && !isReferenced && !isTabeled) {
			<section class="if-section-icon">
				@if (isRequired) {
					<lbca-icon
						[class.if-filled]="valueToReturn"
						class="if-light"
						size="small"
						name="lucide:asterisk"
					/>
				}
			</section>
		}
		<section class="if-section-body">
			@if (!isTabeled) {
				<p class="if-label">{{ labelValue }}</p>
			}
			@if (
				(isEditable && !valueToReturn) ||
				(isReferenced && !valueToReturn && !isTouched && !isLoadingState)
			) {
				<span>-</span>
			}
			@if (isLoadingState) {
				<ng-template [ngTemplateOutlet]="loadingCount"></ng-template>
			}
			<input
				#inputData
				[attr.data-cy]="name || id || _fieldMetadata.entityKey"
				[id]="id || _fieldMetadata.entityKey"
				[name]="name || id || _fieldMetadata.entityKey"
				[autocomplete]="autocomplete"
				[disabled]="isDisabled || isLabeled"
				class="if-input"
				type="text"
				(focus)="focusIn()"
				(blur)="focusOut()"
				(mousedown)="stopPropagation($event)"
				[placeholder]="placeholder"
				(paste)="clickPaste($event)"
				(keydown)="inputKeyUpEvent($event)"
			/>
			<div class="if-focus-marker">&nbsp;</div>
		</section>
		<span [class.w-6]="isLabeled && !isEditable && !inputComponetHelperIconLeftStyle"></span>
		@if (componentFilling) {
			<span
				class="transition duration-400 ease-in-out"
				[ngStyle]="{ width: componentFilling }"
			></span>
		}
		@if (
			!componentFilling && !isLabeled && !isTabeled && !isReferenced && (hasError || isValidIcon)
		) {
			<section class="if-section-icon">
				<div class="icon-box if-icon-validation"></div>
			</section>
		}
		<section
			[ngStyle]="
				valueToReturn && !isLabeled && !isTabeled && copy && !isReferenced
					? { visibility: 'visible' }
					: { visibility: 'hidden' }
			"
			title="Copiar!"
			(click)="copyToClipboard($event)"
			class="if-section-icon cursor-pointer"
		>
			<div class="if-icon-copy"></div>
		</section>
		@if (valueToReturn && isReferenced) {
			<section
				title="Copiar!"
				(click)="copyToClipboard($event)"
				class="if-section-icon cursor-pointer"
			>
				<div class="if-icon-copy"></div>
			</section>
		}

		@if (!isLabeled && removeData && valueToReturn) {
			<section class="if-section-icon">
				<div class="if-trash-container">
					@if (!removeData.remove) {
						<span class="if-trash" (click)="confirmRemoveEvent($event, removeData)"></span>
					}
					@if (removeData.remove) {
						<span
							class="if-cancel-delete-container"
							(click)="confirmRemoveEvent($event, removeData)"
						>
							<span
								class="if-cancel-delete"
								(click)="confirmRemoveEvent($event, removeData)"
							></span>
						</span>
					}
				</div>
			</section>
		}

		@if (isEditable) {
			<section class="if-section-icon">
				<lbca-icon name="lucide:pencil" size="small" class="size-2.5 text-primary"></lbca-icon>
			</section>
		}
		@if (inputComponetHelperIconStyle && !isLabeled && !isTabeled && !isReferenced) {
			<section class="if-section-icon">
				<div [class]="'icon-box ' + inputComponetHelperIconStyle"></div>
			</section>
		}
		@if (maskIcon && !isLabeled && !isDisabled) {
			<section class="if-section-icon">
				<div [class]="'icon-box if-icon-mask ' + maskIcon"></div>
			</section>
		}
		@if (iconRight && !isLabeled && !isTabeled && !isReferenced) {
			<section class="if-section-icon">
				<lbca-icon [name]="iconRight" />
			</section>
		}
		@if ((helperTextValue && !isLabeled && !isTabeled) || inputError) {
			<p class="if-helper" title="{{ helperTextValue }}">
				{{ inputError || helperTextValue }}
			</p>
		}
	</label>
</main>

<ng-template #templateCopy>
	<div class="text-base text-font flex items-center justify-center show">
		Copiado!
		<div class="emojis-happy icon-box ml-[16px]"></div>
	</div>
</ng-template>

<ng-template #loadingCount>
	<div
		class="bars ml-[24px] mt-[2px]"
		[class.left-[24px]]="isLabeled && !isTabeled && !inputComponetHelperIconLeftStyle"
		[class.left-[37px]]="inputComponetHelperIconLeftStyle"
	>
		<div class="bar"></div>
		<div class="bar"></div>
		<div class="bar"></div>
		<div class="bar"></div>
		<div class="bar"></div>
		<div class="bar"></div>
		<div class="bar"></div>
		<div class="bar"></div>
		<div class="bar"></div>
		<div class="bar"></div>
	</div>
</ng-template>
